<!-- src/views/announcements/create.vue -->
<template>
  <form @submit.prevent="handleCreate">
    <section class="container">
      <div class="row">
        <div class="col">
          <div class="mb-2 d-sm-flex align-items-center justify-content-between">
            <span></span>
            <!-- Breadcrumb -->
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="#">{{ $t('common.home') }}</a></li>
              <li class="breadcrumb-item"><a href="#">{{ $t('page.announcements.name') }}</a></li>
              <li class="breadcrumb-item active">{{ $t('common.create') }}</li>
            </ol>
          </div>
        </div>
      </div>

      <!-- Loading Global -->
      <div v-if="loading" class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
        </div>
        <div class="visually-hidden">Carregando...</div>
      </div>

      <div class="card" v-if="!loading">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <span>
              <h4 class="card-title">{{ $t('page.announcements.create_title') }}</h4>
              <p class="card-title-desc"></p>
            </span>
            <span>
              <div class="btn-group">
                <button class="btn btn-primary waves-effect waves-light" id="new" title="{{ $t('common.add') }}"
                  type="button">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </span>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <!-- Type Vehicle -->
            <div class="col form-group">
              <label for="type">{{ $t('page.announcements.inputs.type') }}</label>
              <select class="form-control" id="type" v-model="formData.type_id" @change="getBrands">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="type in vehicles.types" :key="type.id" :value="type.id">
                  {{ type.label }}
                </option>
              </select>
            </div>

            <!-- Brand Vehicle -->
            <div class="col form-group">
              <label for="brand">{{ $t('page.announcements.inputs.brand') }}</label>
              <select class="form-control" id="brand" v-model="formData.brand_id" @change="getModels">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="brand in vehicles.brands" :key="brand.id" :value="brand.id">
                  {{ brand.label }}
                </option>
              </select>
            </div>

            <!-- Model Vehicle -->
            <div class="col form-group">
              <label for="model">{{ $t('page.announcements.inputs.model') }}</label>
              <select class="form-control" id="model" v-model="formData.model_id" @change="getYears">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="model in vehicles.models" :key="model.id" :value="model.id">
                  {{ model.label }}
                </option>
              </select>
            </div>

            <!-- Year Vehicle -->
            <div class="col form-group">
              <label for="year">{{ $t('page.announcements.inputs.yaerModel') }}</label>
              <div class="input-group">
                <select class="form-control" id="year" v-model="formData.year_id">
                  <option value="" disabled>{{ $t('common.please_select') }}</option>
                  <option v-for="year in vehicles.years" :key="year.id" :value="year.id">
                    {{ year.label }}
                  </option>
                </select>
                <select class="form-control" id="year-model" v-model="formData.year_model_id">
                  <option value="" disabled>{{ $t('common.please_select') }}</option>
                  <option v-for="yearModel in vehicles.yearModels" :key="yearModel.id" :value="yearModel.id">
                    {{ yearModel.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Colors -->
            <div class="col form-group">
              <label for="color">{{ $t('page.announcements.inputs.color') }}</label>
              <select id="color" class="form-control" v-model="formData.color">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="color in vehicles.colors" :key="color" :value="color">
                  {{ color }}
                </option>
              </select>
            </div>

            <!-- Fuel -->
            <div class="col form-group">
              <label for="fuel">{{ $t('page.announcements.inputs.fuel') }}</label>
              <select id="fuel" class="form-control" v-model="formData.fuel">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="fuel in vehicles.fuels" :key="fuel" :value="fuel">
                  {{ fuel }}
                </option>
              </select>
            </div>

            <!-- Transmission -->
            <div class="col form-group">
              <label for="transmission">{{ $t('page.announcements.inputs.transmission') }}</label>
              <select id="transmission" class="form-control" v-model="formData.transmission">
                <option value="" disabled>{{ $t('common.please_select') }}</option>
                <option v-for="transmission in vehicles.transmissions" :key="transmission" :value="transmission">
                  {{ transmission }}
                </option>
              </select>
            </div>

            <!-- Price -->
            <div class="col form-group">
              <label for="price">{{ $t('page.announcements.inputs.price') }}</label>
              <input id="price" class="form-control" type="number" v-model="formData.price" />
            </div>
          </div>

          <div class="row">
            <!-- Opcionais -->
            <div class="col form-group">
              <label>{{ $t('page.announcements.inputs.optionals') }}</label>
              <div class="form-check" v-for="optional in vehicles.optionals" :key="optional.id">
                <input class="form-check-input" type="checkbox" :id="`optional-${optional.id}`" :value="optional.id"
                  v-model="formData.optionals" />
                <label class="form-check-label" :for="`optional-${optional.id}`">
                  {{ optional.name }}
                </label>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Title -->
            <div class="col-12 form-group">
              <label for="title">{{ $t('page.announcements.inputs.title') }}</label>
              <input id="title" class="form-control" type="text" v-model="formData.title">
            </div>

            <!-- Description -->
            <div class="col-12 form-group">
              <label for="description">{{ $t('page.announcements.inputs.description') }}</label>
              <textarea id="description" class="form-control" v-model="formData.description" rows="4"></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <div class="text-center">
            <!-- Buttons -->
            <button class="btn btn-secondary" type="button" @click="$emit('cancel')">{{ $t('common.cancel') }}</button>
            <button class="btn btn-primary" type="submit">{{ isEdit ? $t('common.update') : $t('common.save')
              }}</button>
          </div>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useAnnouncementStore } from "@/stores/announcementStore";
import { useVehicleStore } from "@/stores/vehicleStore";
import { toast } from "vue3-toastify";

export default {
  name: "AnnouncementCreate",
  setup() {
    const router = useRouter();
    const announcementStore = useAnnouncementStore();
    const vehicleStore = useVehicleStore();

    const loading = ref(false);
    const errorMessage = ref("");

    const vehicles = ref({
      types: [],
      brands: [],
      models: [],
      colors: [],
      optionals: [],
      yearModels: [],
    });

    const formData = ref({
      type_id: "",
      brand_id: "",
      model_id: "",
      year_id: "",
      year_model_id: "",
      color: "",
      fuel: "",
      transmission: "",
      price: "",
      optionals: [],
      title: "",
      description: "",
    });

    const getTypes = async () => {
      loading.value = true;
      try {
        vehicles.value.types = await vehicleStore.getTypes();
      } catch (error) {
        toast.error("Erro ao carregar os Tipos de Veiculos.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    const getBrands = async () => {
      loading.value = true;
      try {
        vehicles.value.brands = await vehicleStore.getBrands(formData.value.type_id);
      } catch (error) {
        toast.error("Erro ao carregar as Marcas de Veiculos.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    const getModels = async () => {
      loading.value = true;
      try {
        vehicles.value.models = await vehicleStore.getModels(formData.value.type_id, formData.value.brand_id);
      } catch (error) {
        toast.error("Erro ao carregar os Modelos de Veiculos.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    const getYears = async () => {
      loading.value = true;
      try {
        vehicles.value.years = await vehicleStore.getYears(formData.value.type_id, formData.value.brand_id, formData.value.model_id);
      } catch (error) {
        toast.error("Erro ao carregar os Anos dos Modelos.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    const getColors = async () => {
      loading.value = true;
      try {
        vehicles.value.colors = await vehicleStore.getColors();
      } catch (error) {
        toast.error("Erro ao carregar as Cores.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    const getOptionals = async () => {
      loading.value = true;
      try {
        vehicles.value.optionals = await vehicleStore.getOptionals();
      } catch (error) {
        toast.error("Erro ao carregar os Opcionais.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          theme: toast.THEME.COLORED,
          className: "foo-bar",
        });
      } finally {
        loading.value = false;
      }
    };

    watch(
      () => formData.value.model_id,
      (newModelId) => {
        const selectedModel = vehicles.value.models.find((model) => model.id === newModelId);
        formData.value.title = selectedModel ? selectedModel.label : "";
      },

      () => formData.value.year_id,
      (newYearId) => {
        if (newYearId) {
          const selectedYear = vehicles.value.years.find(
            (year) => year.id === parseInt(newYearId, 10)
          );

          if (selectedYear) {
            const yearMatch = selectedYear.label.match(/^\d{4}/);
            if (yearMatch) {
              const extractedYear = parseInt(yearMatch[0], 10);
              const nextYear = extractedYear + 1;

              vehicles.value.yearModels = [
                { id: extractedYear, label: extractedYear.toString() },
                { id: nextYear, label: nextYear.toString() },
              ];

              formData.value.year_model_id = "";
            }
          }
        } else {
          vehicles.value.yearModels = [];
          formData.value.year_model_id = "";
        }
      }
    );

    const handleCreate = async () => {
      loading.value = true;
      try {
        await announcementStore.createAnnouncement(formData.value);
        router.push({ name: "announcement-index" });
      } catch (error) {
        console.error("Erro ao criar anúncio:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      getTypes();
      getColors();
      getOptionals();
    });

    return {
      loading,
      errorMessage,
      vehicles,
      formData,
      getBrands,
      getModels,
      getYears,
      getColors,
      getOptionals,
      handleCreate,
    };
  },
};
</script>

<style scoped></style>